import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const Payment = ({
  t,
}) => (
  <React.Fragment>
    <section className="customerSetting boxs">
      <div className="container">
        <div className="payment-page-company-logo">
          <img src="img/logo.png" alt="img" className="img-responsive" />
        </div>
        <div className="payment-block">
          <div>
            <p className="center">{t('Oops')}.</p>
            <p className="center">{t('This portal is not reachable anymore')}.</p>
            <p className="center">{t('Contact your Admin')}.</p>
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

Payment.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Payment;



// WEBPACK FOOTER //
// ./src/views/payment/Payment.js